export const gameAttributesSyncedToUi = [
	"alwaysShowCountry",
	"challengeNoRatings",
	"fantasyPoints",
	"gender",
	"hideDisabledTeams",
	"homeCourtAdvantage",
	"lid",
	"neutralSite",
	"numPeriods",
	"numWatchColors",
	"phase",
	"quarterLength",
	"season",
	"spectator",
	"startingSeason",
	"teamInfoCache",
	"userTid",
	"userTids",
] as const;
